import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SectionReveal } from '../components/SectionReveal';
import { TestimonialCard } from '../components/TestimonialCard';
import { MapPinIcon, BrainCircuitIcon, UsersIcon, ClockIcon } from 'lucide-react';
import { FaqSection } from '../components/FaqSection';
export function ProgrammeLiberty() {
  return <div className="min-h-screen bg-cream" data-id="element-296">
      <HeroSection title="Libérez-vous du salariat par l'investissement intelligent." subtitle="Un programme de coaching exclusif pour celles qui veulent se lancer dans le business et l'immobilier, avec un Mindset de bâtisseuse." ctaText="Réserver mon appel découverte" ctaLink="https://calendly.com/sarahmarte/liberty-program" theme="blush" backgroundImage="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070&auto=format&fit=crop" data-id="element-297" />

      {/* Programme Content */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-298">
        <SectionReveal data-id="element-299">
          <div className="text-center mb-16" data-id="element-300">
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-301">
              Le Programme d'Excellence
            </h2>
            <p className="text-navy/70 max-w-2xl mx-auto" data-id="element-302">
              Une approche holistique alliant stratégies financières concrètes
              et reprogrammation mentale.
            </p>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-303">
          <SectionReveal delay={0.1} data-id="element-304">
            <div className="bg-white rounded-3xl p-10 h-full shadow-xl shadow-pink-100/40 border border-blush hover:-translate-y-1 transition-transform" data-id="element-305">
              <div className="bg-blush-light w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-306">
                <MapPinIcon className="w-8 h-8 text-rosegold" data-id="element-307" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-308">
                Stratégies Immobilières
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-309">
                Apprenez à investir intelligemment sur les marchés les plus
                porteurs : Dubaï, Europe et Maroc. Analyse de rentabilité,
                fiscalité et gestion à distance.
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.2} data-id="element-310">
            <div className="bg-white rounded-3xl p-10 h-full shadow-xl shadow-pink-100/40 border border-blush hover:-translate-y-1 transition-transform" data-id="element-311">
              <div className="bg-blush-light w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-312">
                <BrainCircuitIcon className="w-8 h-8 text-rosegold" data-id="element-313" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-314">
                Coaching Mindset
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-315">
                Briser vos plafonds de verre. Un accompagnement individuel pour
                détruire vos croyances limitantes liées à l'argent et adopter la
                psychologie des investisseurs à succès.
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.3} data-id="element-316">
            <div className="bg-white rounded-3xl p-10 h-full shadow-xl shadow-pink-100/40 border border-blush hover:-translate-y-1 transition-transform" data-id="element-317">
              <div className="bg-blush-light w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-318">
                <UsersIcon className="w-8 h-8 text-rosegold" data-id="element-319" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-320">
                Cercle Exclusif
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-321">
                Accès privilégié à un réseau privé d'investisseurs et
                d'entrepreneuses. Partage d'opportunités off-market et synergies
                business.
              </p>
            </div>
          </SectionReveal>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-white" data-id="element-322">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323">
          <SectionReveal data-id="element-324">
            <div className="text-center mb-16" data-id="element-325">
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-326">
                Elles ont osé investir en elles
              </h2>
            </div>
          </SectionReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-327">
            <TestimonialCard name="Sofia Rossi" location="Genève, Suisse" photo="https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=400&auto=format&fit=crop&crop=faces" quote="Le coaching mindset avec Sarah a été un déclic. J'ai investi dans mon premier appartement à Dubaï 4 mois après notre première session. Elle voit ce que tu ne vois pas encore." result="Premier investissement immo · ROI 8%/an" delay={0.1} data-id="element-328" />
            <TestimonialCard name="Émilie Dubois" location="Marseille, France" photo="https://cdn.magicpatterns.com/uploads/jHcPUBEjNXMCiPcoWWXDkb/Gemini_Generated_Image_r9ezq7r9ezq7r9ez.png" quote="Sarah a une exigence rare. Elle te tire vers le haut sans complaisance. C'est ce qu'il fallait pour briser mon plafond de verre." result="Revenus x3 en 1 an" delay={0.2} data-id="element-329" />
          </div>
        </div>
      </section>

      {/* Entry Level Option */}

      {/* FAQ */}
      <FaqSection subtitle="Les réponses aux questions que se posent les femmes avant de rejoindre le Programme Liberty." items={[{
      question: "Je n'y connais rien en immobilier, est-ce que ce programme est pour moi ?",
      answer: "Oui. Le Programme Liberty est conçu pour les débutantes comme pour les investisseuses confirmées. Sarah te guide pas à pas, des bases jusqu'aux stratégies avancées (Dubaï, Europe, Maroc), pour que tu passes à l'action en confiance."
    }, {
      question: 'Quelle différence entre le coaching individuel à 130€ et le programme complet ?',
      answer: "Le coaching 1-1 à 130€ est une session unique d'une heure pour débloquer une situation, valider un projet ou obtenir l'expertise de Sarah sur un point précis. Le Programme Liberty est un accompagnement complet sur plusieurs mois qui couvre stratégies immobilières, coaching mindset et accès au cercle d'investisseurs."
    }, {
      question: "Quel budget faut-il pour commencer à investir dans l'immobilier ?",
      answer: "Cela dépend du marché et de la stratégie. Sarah t'aide à identifier le meilleur point d'entrée selon ta situation : tu peux commencer avec un apport modéré pour certains marchés (Maroc, France de province) ou viser plus haut pour Dubaï. Le mindset et la stratégie comptent autant que le budget initial."
    }, {
      question: 'En quoi consiste exactement le coaching mindset ?',
      answer: "C'est un accompagnement individuel qui te permet d'identifier et de briser les croyances limitantes liées à l'argent, à la réussite et à ta légitimité d'entreprendre. Sarah utilise des outils concrets pour adopter la psychologie des investisseurs à succès et te faire passer à l'action."
    }, {
      question: 'Le programme se fait-il en présentiel ou à distance ?',
      answer: "Tout le programme se déroule à distance, en visio, pour s'adapter à ton rythme de vie. Sarah étant basée entre Dubaï et le Maroc, le format à distance permet une flexibilité maximale tout en gardant une qualité d'accompagnement premium."
    }, {
      question: "C'est quoi exactement le cercle d'investisseurs exclusifs ?",
      answer: "C'est un réseau privé composé d'investisseurs, d'entrepreneuses et de partenaires triés sur le volet. Tu y as accès aux opportunités off-market, à des synergies business et à un environnement où l'ambition est la norme. C'est un véritable accélérateur."
    }, {
      question: 'Comment réserver ma session ou rejoindre le programme ?',
      answer: 'Pour une session 1-1 (130€), tu peux directement réserver sur le calendrier de coaching. Pour le programme complet, commence par un appel découverte gratuit avec Sarah pour valider que le programme correspond à tes objectifs.'
    }]} data-id="element-330" />

      {/* Final CTA */}
      <section className="py-24 bg-cream text-center px-4" data-id="element-331">
        <SectionReveal data-id="element-332">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-6" data-id="element-333">
            Votre liberté n'attend plus.
          </h2>
          <p className="text-navy/70 max-w-2xl mx-auto mb-10 text-lg" data-id="element-334">
            Rejoignez la liste d'attente pour la prochaine cohorte du Programme
            Liberty. Les places sont limitées pour garantir l'intimité du
            cercle.
          </p>
          <a href="https://calendly.com/sarahmarte/liberty-program" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-navy border border-blush px-10 py-4 rounded-full font-medium shadow-xl shadow-pink-100/50 hover:bg-blush-light hover:-translate-y-1 transition-all" data-id="element-335">
            Réserver mon appel découverte
          </a>
        </SectionReveal>
      </section>
    </div>;
}